/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
/* eslint-disable jsx-a11y/anchor-is-valid  */
import React, { useEffect, useMemo, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Container, Trigger } from 'app/components';
import parse from 'html-react-parser';
import { Title, AdvertisementWrapper, Expander } from './styles';

const propTypes = {
  advertising: PropTypes.shape({
    cinema: PropTypes.oneOfType([PropTypes.array, PropTypes.any]).isRequired,
    online: PropTypes.oneOfType([PropTypes.array, PropTypes.any]).isRequired,
    press: PropTypes.oneOfType([PropTypes.array, PropTypes.any]).isRequired
  }).isRequired,
  getCinemaAdvertising: PropTypes.func.isRequired,
  getOnlineAdvertising: PropTypes.func.isRequired,
  getPressInfo: PropTypes.func.isRequired
};

// const getPressDetails = data => {
//   const details = { ...data };

//   const infoList = [];

//   for (let i = 0; i < details?.pressinfo?.length; i++) {
//     if (i === 0) {
//       infoList.push({
//         headline: details?.pressinfo[i]?.headline,
//         list: [details.pressinfo[i]]
//       });
//     } else {
//       const foundInfo = infoList?.find(item => item?.headline === details?.pressinfo[i]?.headline);

//       if (foundInfo?.headline) {
//         const index = infoList?.findIndex(item => item?.headline === foundInfo?.headline);

//         infoList[index].list = [...infoList[index].list, details?.pressinfo[i]];
//       } else {
//         infoList.push({
//           headline: details?.pressinfo[i]?.headline,
//           list: [details.pressinfo[i]]
//         });
//       }
//     }
//   }

//   return {
//     ...details,
//     pressinfo: infoList
//   };
// };

const CinemaAdvertising = ({
  advertising,
  getCinemaAdvertising,
  getOnlineAdvertising,
  getPressInfo
}) => {
  const [t, i18n] = useTranslation();
  const { language } = i18n;

  const [isExpanded, setIsExpanded] = useState([]);
  const [advertisingData, setadvertisingData] = useState({
    cinema: {
      headline: '',
      headlineEN: '',
      Description: '',
      DescriptionEN: ''
    },
    online: {
      headline: '',
      headlineEN: '',
      Description: '',
      DescriptionEN: ''
    },
    press: {
      headline: '',
      headlineEN: '',
      Description: '',
      DescriptionEN: ''
    }
  });

  useEffect(() => {
    getCinemaAdvertising();
    getOnlineAdvertising();
    getPressInfo();
  }, []);

  useEffect(() => {
    if (advertising?.cinema?.length && advertising?.online?.length && advertising?.press?.length) {
      setadvertisingData(prev => ({
        ...prev,
        cinema: advertising?.cinema[0],
        online: advertising?.online[0],
        press: advertising?.press[0]
      }));
    }
  }, [advertising]);

  const languageContents = useMemo(
    () => ({
      headline: language === 'en' ? 'headlineEN' : 'headline',
      headline2: language === 'en' ? 'headline2EN' : 'headline2',
      Description: language === 'en' ? 'DescriptionEN' : 'Description',
      description: language === 'en' ? 'descriptionEN' : 'description',
      link: language === 'en' ? 'linkEN' : 'link',
      linkDescription: language === 'en' ? 'linkDescriptionEN' : 'linkDescription'
    }),
    [language]
  );

  const setExpandCb = useCallback(
    id => {
      const expandList = [...isExpanded];

      if (expandList.includes(id)) {
        expandList.splice(expandList.indexOf(id), 1);
      } else {
        expandList.push(id);
      }

      setIsExpanded(expandList);
    },
    [isExpanded]
  );

  return (
    <Container>
      <Title>{t('common.advertising_title')}</Title>
      <AdvertisementWrapper>
        <div className="advertisement-wrapper__cinema-wrapper">
          <h2>{advertisingData?.cinema?.[languageContents.headline]}</h2>
          <div className="advertisement-wrapper__cinema-content">
            {(advertisingData?.cinema?.Description !== null || advertisingData?.cinema?.DescriptionEN !== null) && parse(advertisingData?.cinema?.[languageContents.Description])}
          </div>
        </div>
        {advertisingData?.online?.id && <div className="advertisement-wrapper__online-divider" />}
        <div className="advertisement-wrapper__online-wrapper">
          <h2>{advertisingData?.online?.[languageContents.headline]}</h2>
          <div className="advertisement-wrapper__online-content">
            {(advertisingData?.online?.Description !== null || advertisingData?.online?.DescriptionEN !== null) && parse(advertisingData?.online?.[languageContents.Description])}
          </div>
        </div>
        {advertisingData?.press?.id && <div className="advertisement-wrapper__press-divider" />}
        <div className="advertisement-wrapper__press-wrapper">
          <h2>{advertisingData?.press?.[languageContents.headline]}</h2>
          <div className="advertisement-wrapper__press-content">
            {(advertisingData?.press?.Description !== null || advertisingData?.press?.DescriptionEN !== null) && parse(advertisingData?.press?.[languageContents.Description])}
          </div>
          <div className="advertisement-wrapper__press-info-wrapper">
            <h2>{advertisingData?.press?.[languageContents.headline2]}</h2>
            {
              advertisingData?.press?.pressinfo && (
                <div className="advertisement-wrapper__press-info-content">
                  {advertisingData?.press?.pressinfo?.map(press => (
                    <>
                      <div key={press?.headline} className="advertisement-wrapper__press-info-item">
                        <h3>{press?.[languageContents.headline]}</h3>
                        <Trigger
                          className=""
                          isExpanded={isExpanded.includes(press?.headline)}
                          onClick={() => setExpandCb(press?.headline)}
                        >
                          <span className="_with-chevron" />
                        </Trigger>
                      </div>
                      <Expander isExpanded={isExpanded.includes(press?.headline)}>
                        <ul>
                          {press?.items?.map((details, index) => {
                            const description = language === 'en' || language === 'en-US' ? details?.descriptionEN : details?.description;
                            if (description !== null) {
                              return (
                                <li key={index}>
                                  <h3>{parse(description)}</h3>
                                  {(details?.PDF !== null || details?.link !== null) &&
                                    <>
                                      <div>
                                        <a href={language === 'en' || language === 'en-US' ? details?.linkEN : details?.link} target="_blank" rel="noopener noreferrer">
                                          {language === 'en' || language === 'en-US' ? details?.linkDescriptionEN : details?.linkDescription}
                                        </a>
                                      </div>
                                      <div>
                                        <a href={details?.PDF} target="_blank" rel="noopener noreferrer">
                                          {language === 'en' || language === 'en-US' ? details?.PDFDescriptionEN : details?.PDFDescription}
                                        </a>
                                      </div>
                                    </>
                                  }
                                </li>
                              );
                            }
                            return null;
                          })}
                        </ul>
                      </Expander >
                    </>
                  ))}
                </div>
              )}
          </div>
        </div>
      </AdvertisementWrapper>
    </Container >
  );
};

CinemaAdvertising.propTypes = propTypes;

export default CinemaAdvertising;
